// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2jErY","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1FKRB"};